import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

import { RoutingPaths } from 'app/routes/routes'

import { CloseCircle } from 'entities/close-circle/model'
import { EmptyPage } from 'entities/close-circle/ui/empty-page'

import { CloseCircleApi } from 'shared/api/close-circle'
import { MAX_LENGTH_CLOSE_CIRCLE } from 'shared/constants'
import { ButtonAddCircle } from 'shared/ui/button-add-circle'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { ItemArrow } from 'shared/ui/item-arrow'
import { Paper } from 'shared/ui/paper'

import CloseCircleSkeleton from './components/close-circle-skeleton'
import s from './styles.module.scss'

const CircleList = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const [closeCircleData, setCloseCircleData] = useState<CloseCircle[] | null>(
    null,
  )
  const [loading, setLoading] = useState<boolean>(true)

  const getCircle = async () => {
    try {
      const { data } = await CloseCircleApi.getUserDocuments()
      setCloseCircleData(data.data)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCircle()
  }, [])

  return (
    <div className={clsx('container', s.container)}>
      <div className={s.header}>
        <HeaderGoBack
          title={t('сlose_circlу')}
          variant="grey"
          buttonWhite
        />
      </div>

      {loading ? (
        <div className={s.card}>
          {Array(8)
            .fill(1)
            .map(() => (
              <CloseCircleSkeleton key={nanoid()} />
            ))}
        </div>
      ) : (
        <div className={s.card}>
          {closeCircleData?.map((circle) => (
            <Paper
              key={circle.id}
              radius={16}
              padding={[2, 12]}
            >
              <ItemArrow
                onClick={() => {
                  navigate(
                    RoutingPaths.closeCircle.detailCloseCircle.path(
                      String(circle.id),
                    ),
                  )
                }}
                title={circle.label}
              />
            </Paper>
          ))}

          {closeCircleData?.length &&
          closeCircleData?.length < MAX_LENGTH_CLOSE_CIRCLE ? (
            <ButtonAddCircle
              onClick={() => navigate(RoutingPaths.closeCircle.form.path())}
              content={t('add_close')}
              leftIcon={true}
            />
          ) : null}
        </div>
      )}

      {(!closeCircleData?.length || closeCircleData == null) && !loading ? (
        <div className={s.empty}>
          <EmptyPage
            isShowButton={
              MAX_LENGTH_CLOSE_CIRCLE >= (closeCircleData?.length || 0)
            }
          />
        </div>
      ) : null}
    </div>
  )
}

export default CircleList
